import PersonalInfo from "./personalInfo";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "./myProfile.css";
import NewAddress from "./newAddress";
import Subscription from "./subscription";
import GiveFeedback from "./giveFeedback";
import NeedHelp from "./NeedHelp";
import MyRequests from "./MyRequests";
import LogoutProfile from "./LogoutProfile";
import FAQ from "./FAQ";

export default function MyProfile() {
  const [activeNavigation, setActiveNavigation] = useState();
  const navigate = useNavigate();
  const [showLogoutPopUp, setShowLogoutPopUp] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    let jwt = JSON.parse(localStorage.getItem("homeshiksha-jwt"));
    if (!jwt) navigate("/");
    else setActiveNavigation(() => "personal");
  }, []);

  const resetPopUp = () => {
    setShowLogoutPopUp(false);
    setActiveNavigation("personal");
  };

  const handleConfirmLogout = () => {
    console.log("User logged out successfully");
    // Navigate to home page or login page
    navigate("/");
  };

  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
  }, []);

  return (
    <main className="main">
      <section className="pathway-requestBtn--wrapper">
        <div className="pathway--wrapper">
          <div
            onClick={() => {
              navigate("/dashboard");
            }}>
            <img src="/homeicon.svg" alt="homeicon icon" width="18" height="17" />
          </div>
          <div>
            <img src="/rightArrow.svg" alt="rightArrow icon" width="11" height="11" />
          </div>
          <div className="pathway--btn">Account</div>
          <div>
            <img src="/rightArrow.svg" alt="rightArrow icon" width="11" height="11" />
          </div>
          <div className="pathway--btn">
            {activeNavigation == "personal"
              ? "Personal Info"
              : activeNavigation == "requests"
              ? "My Requests"
              : activeNavigation == "children"
              ? "My Children"
              : activeNavigation == "address"
              ? "My Address"
              : // : activeNavigation == 'Counselling'
              // ? 'Counselling'
              activeNavigation == "Subscription"
              ? "Subscription"
              : activeNavigation == "faq"
              ? "FAQ"
              : activeNavigation == "giveFeedback"
              ? "Give Feedback"
              : activeNavigation == "needHelp"
              ? "Help & Support"
              : activeNavigation == "settings"
              ? "Settings"
              : ""}
          </div>
        </div>
      </section>
      <section className="personal-info--container">
        {!isMobile && (
          <div className="personal-info--navigation--wrapper">
            <div className="personal-info--navigation">
              <div
                onClick={() => {
                  setActiveNavigation("personal");
                }}
                className={`${
                  activeNavigation == "personal"
                    ? "active-personal-info--navigation"
                    : "unactive-personal-info--navigation"
                }`}>
                Personal Info
              </div>
              <div
                onClick={() => {
                  setActiveNavigation("requests");
                }}
                className={`${
                  activeNavigation == "requests"
                    ? "active-personal-info--navigation"
                    : "unactive-personal-info--navigation"
                }`}>
                My Requests
              </div>
              {/* <div onClick={()=>{setActiveNavigation('children')}} className={`${(activeNavigation=='children')?'active-personal-info--navigation':'unactive-personal-info--navigation'}`}>My Children</div> */}
              <div
                onClick={() => {
                  setActiveNavigation("address");
                }}
                className={`${
                  activeNavigation == "address"
                    ? "active-personal-info--navigation"
                    : "unactive-personal-info--navigation"
                }`}>
                My Address
              </div>
              {/* <div
              onClick={() => {
                setActiveNavigation('Counselling');
              }}
              className={`${
                activeNavigation == 'Counselling'
                  ? 'active-personal-info--navigation'
                  : 'unactive-personal-info--navigation'
              }`}>
              Counselling
            </div> */}
              <div
                onClick={() => {
                  setActiveNavigation("Subscription");
                }}
                className={`${
                  activeNavigation == "Subscription"
                    ? "active-personal-info--navigation"
                    : "unactive-personal-info--navigation"
                }`}>
                Subscription
              </div>
              <div
                onClick={() => {
                  setActiveNavigation("faq");
                }}
                className={`${
                  activeNavigation == "faq" ? "active-personal-info--navigation" : "unactive-personal-info--navigation"
                }`}>
                FAQ's
              </div>
              <div
                onClick={() => {
                  setActiveNavigation("needHelp");
                }}
                className={`${
                  activeNavigation == "needHelp"
                    ? "active-personal-info--navigation"
                    : "unactive-personal-info--navigation"
                }`}>
                Need Help?
              </div>
              {isMobile && (
                <div
                  onClick={() => {
                    setActiveNavigation("giveFeedback");
                  }}
                  className={`${
                    activeNavigation == "giveFeedback"
                      ? "active-personal-info--navigation"
                      : "unactive-personal-info--navigation"
                  }`}>
                  Give Feedback
                </div>
              )}
              {isMobile && (
                <div
                  onClick={() => {
                    setActiveNavigation("logout");
                    setShowLogoutPopUp(true);
                  }}
                  className={`${
                    activeNavigation == "logout"
                      ? "active-personal-info--navigation"
                      : "unactive-personal-info--navigation"
                  }`}>
                  Log Out
                </div>
              )}

              {/* <div onClick={()=>{setActiveNavigation('settings')}} className={`${(activeNavigation=='settings')?'active-personal-info--navigation':'unactive-personal-info--navigation'}`}>Settings</div> */}

              {/* <div><NavLink to='/' >Log Out</NavLink></div> */}
            </div>
            {!isMobile && (
              <div className="personal-info--navigation">
                <div
                  onClick={() => {
                    setActiveNavigation("giveFeedback");
                  }}
                  className={`${
                    activeNavigation == "giveFeedback"
                      ? "active-personal-info--navigation"
                      : "unactive-personal-info--navigation"
                  }`}>
                  Give Feedback
                </div>

                <div
                  onClick={() => {
                    setActiveNavigation("logout");
                    setShowLogoutPopUp(true);
                  }}
                  className={`${
                    activeNavigation == "logout"
                      ? "active-personal-info--navigation"
                      : "unactive-personal-info--navigation"
                  }`}>
                  Log Out
                </div>
              </div>
            )}
          </div>
        )}
        <div className="personal-info--content--page">
          {activeNavigation == "personal" ? <PersonalInfo /> : <></>}
          {activeNavigation == "requests" ? <MyRequests /> : <></>}
          {activeNavigation == "children" ? <div>children</div> : <></>}

          {activeNavigation == "address" ? <NewAddress /> : <></>}
          {/* {activeNavigation == 'Counselling' ? <Counselling /> : <></>} */}
          {activeNavigation == "Subscription" ? <Subscription /> : <></>}
          {activeNavigation == "faq" ? <FAQ /> : <></>}
          {activeNavigation == "giveFeedback" ? <GiveFeedback onClose={resetPopUp} /> : <></>}
          {activeNavigation == "needHelp" ? <NeedHelp /> : <></>}
          {/* {(activeNavigation=='settings')?:<></>} */}
          {activeNavigation == "settings" ? <div>settings</div> : <></>}
        </div>

        {showLogoutPopUp && <LogoutProfile onClose={resetPopUp} onConfirmLogout={handleConfirmLogout} />}
      </section>
    </main>
  );
}
